import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {emailFormat} from '../../../common/validations';
import {CompletePaymentRequest} from '../../../../models/request/complete-payment-request.model';
import {PAISES_MUNDO} from '../../../../models/application/countriesWorld';
import {DialogService} from '../../../../services/dialog.service';
import {SessionService} from '../../../../services/session.service';
import {PaymentService} from '../../../../services/payment.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-registro',
    templateUrl: './registro.component.html',
    styleUrls: ['./registro.component.scss']
})
export class RegistroComponent implements OnInit {

    public tipoCuenta = new FormControl(false);
    public acepptTerms = false;
    public valid = false;
    public form: FormGroup;
    countries: any;

    constructor(
        private fb: FormBuilder,
        // tslint:disable-next-line:variable-name
        private _dialog: DialogService,
        // tslint:disable-next-line:variable-name
        private _session: SessionService,
        // tslint:disable-next-line:variable-name
        private _payment: PaymentService,
        private router: Router
    ) {
        this.countries = PAISES_MUNDO.sort(
            (a, b) => {
                if (a.name_es > b.name_es) {
                    return 1;
                }
                if (a.name_es < b.name_es) {
                    return -1;
                }
                return 0;
            }
        );
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            username: [''],
            name: ['', Validators.compose([Validators.required])],
            lastName: ['', Validators.compose([Validators.required])],
            secondLastName: [''],
            email: ['', Validators.compose([Validators.required, emailFormat])],
            isCompany: [this.tipoCuenta, Validators.compose([Validators.required])]
        });
        console.log(this.getData());
    }

    onSubmit(): void {
        this._session.getSessionService();
        if (this.form.valid) {
            this._dialog.showConfirmationDialog(
                'Confirmar Operação',
                'Todos os dados estão corretos?',
                () => {
                    const register = {
                        user: {
                            username: this.form.controls.email.value,
                            name: this.form.controls.name.value,
                            lastName: this.form.controls.lastName.value,
                            secondLastName: this.form.controls.secondLastName.value,
                            email: this.form.controls.email.value,
                            phone: this.getData().phone,
                            maxSigns: 3,
                            isTryAccount: true,
                            isRecurrentPlan: false,
                            isCompany: this.tipoCuenta.value,
                            countryCode: this.getData().countryCode,
                            countryId: 1
                        },
                        idSourceSystem: '4',
                        language: 'pt'
                    };
                    this._session.validEmail(this.form.controls.email.value).subscribe(
                        res => {
                            if (res.success) {
                                this._session.register(register).subscribe(
                                    response => {
                                        // tslint:disable-next-line:max-line-length
                                        if (response.success) {
                                            this._dialog.showNotificationDialog('Conta criada com sucesso.', 'Sua senha foi enviada para seu email');
                                            this.addDataLayerCreate();
                                            this.router.navigate(['/']);
                                            this._session.setPaymentAccount(null);
                                            this.form.reset();
                                        } else {
                                            this._dialog.showNotificationDialog('Ups!', 'Não foi possível criar sua conta, tente mais tarde.');
                                        }
                                    },
                                    () => {
                                        this._dialog.showNotificationDialog('Ups!', 'Não foi possível criar sua conta, tente mais tarde.');
                                    }
                                );
                            } else {
                                this._dialog.showNotificationDialog('Ups!', 'O email digitado já foi cadastrado.');
                            }
                        },
                        () => {
                            this._dialog.showNotificationDialog('Ups!', 'Ocorreu um erro inesperado, tente mais tarde.');
                        });
                }
            );
        } else {
            this._dialog.showNotificationDialog('Ups!', 'Todos os campos são obrigatórios.');
        }
    }

    getData(): any {
        const data = sessionStorage.getItem('TUSE9WSUw=');
        if (data) {
            return JSON.parse(atob(data));
        }
        return null;
    }

    addDataLayerCreate(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        // @ts-ignore
        dataLayer.push({
            event: 'sign_up',
            method: 'FAD'
        });
    }

}
